<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty Layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Main Layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<main-layout *ngIf="layout === 'main'" ></main-layout>